import React from 'react';

import Frame from '../frame';
import Style from '../sdgs/style';
import Chart from '../sdgs/chart';
import { useSdgs } from '../sdgs/hook';

const EventsDistribution = ({
  data = null,
  t = (t) => t,
  period = 'past12Months',
}) => {
  const {
    items,
    _totalEvents,
    setFrameActions,
  } = useSdgs({ data, activeFilter: period });

  return (
    <Frame
      title={t('Dashboard::SDG Contributions')}
      onInit={actions => setFrameActions(actions)}
      overflowVisible
    >
      {!!data && (
        <Style className="small">
          <Chart
            t={t}
            className="small"
            data={items}
            totalEvents={data ? data.totalEvents : 0}
            showSources={false}
          />
          <div className="overview-footer">
            <p>
              <span className="text-blue">
                {_totalEvents || 0}
              </span>
              {' '}
              {t('Dashboard::interventions')}
              {' '}
              {t('Dashboard::related to')}
              {' '}
              <span className="text-blue">{items.length}</span>
              {' '}
              {t('Dashboard::SDGs')}
            </p>
          </div>
        </Style>
      )}
    </Frame>
  );
}

export default EventsDistribution;
